<template>
  <div class="rule-wraper">
    <TxButton class="rule" src="guize" name="活动规则" @click="is_show = true"></TxButton>
    <TxDialog v-model="is_show">
      <div class="rule-container">
        <div class="rule-text m-auto">
          <div class="t-left">
            活动时间:
          </div>
          11月26日18:00-【弱水三千】开服
          <div class="t-left">
            奖励领取:
          </div>
          年度服【弱水三千】开服后 - 开服后30日
          <br>
          <span class="red">年度服【弱水三千】开服时间请关注后续官方通知</span>
          <ol>
            <li>
              1 .活动期间，少侠在本页面成功预约，即可在 <span class="red">年度服【弱水三千】</span>开服后获得新服预约奖励，同时可获得《天下：万象》预约活动抽奖次数*3。
            </li>
            <li>
              2 .活动期间分享本页面，可额外获得《天下：万象》预约活动抽奖次数*2
            </li>
            <li>
              3 .预约奖励将通过游戏内NPC-小玉发放，请少侠前往<span class="red">腾龙渡-小玉</span>处领取奖励
            </li>
            <li>
              4 .请少侠留意：预约奖励仅限预约账号下的 <span class="red">1个角色</span>领取，且只能领取一次
            </li>
            <li>
              5 .请少侠留意：通过年度服【弱水三千】预约活动获取的《天下：万象》抽奖次数会自动发放至参与年度服【弱水三千】新服预约所用的账号下
            </li>
          </ol>
        </div>
      </div>
    </TxDialog>
  </div>
</template>
<script setup>
import { computed, shallowRef } from 'vue';
const is_show = shallowRef(false);
</script>
<style lang="scss" scoped>
.rule {
  position: fixed;
  right: 0px;
  top: 150px;
  z-index: 99;
  color: #e8e8e8;
  font-size: 20px;
}

.dialog-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rule-container {
  display: flex;
  // @include bg('guize-diban');
}

.rule-text {
  width: 480px;
  height: 460px;
  position: relative;
  top: 160px;
  overflow-y: auto;
  color: white;
  font-size: 25px;
  font-family: 'rs';
}
ol > li{
  margin-top: 10px;
}
</style>
